
import Vue from "vue";
import AppDraggableResizeCombo from "@/components/layout-editor/DraggableResizeCombo.vue";
import { QrCode } from "../../utils/label-layout/qr-code";

export default Vue.extend({
	props: {
		qrcode: {
			type: Object as ()=>QrCode,
			required: true
		},
	},
	components: {
		AppDraggableResizeCombo
	}
});
